import { Navigate } from 'react-router-dom';
import { Inbox } from 'lucide-react';
import { AppLayout } from '@/components/layout/app-layout';
import { useAuth } from '@/features/auth/hooks/use-auth';
import { HoyTab } from '@/features/smart-pricing/components/hoy-tab';
import { VueltaSheet } from '@/features/smart-pricing/components/vuelta-sheet';
import { MarcoCompite } from '../ui/marco-compite';
import { EncabezadoCompite } from '../ui/encabezado-compite';
import { Saludo } from '../ui/saludo';
import { AvisoCambiosNuevos } from '../components/aviso-cambios-nuevos';
import { AvisoDemo, AVISO_DECISIONES_DEMO } from '@/features/mini-prixia/components/aviso-demo';
import {
  RUTAS_COMPITE,
  useOrquestacionCompite,
  usePermisosDeCompite,
} from '../hooks/use-orquestacion-compite';

/**
 * Compite › Decisiones (antes «Hoy» de Estrategias de Mercado). La portada del
 * día de la maqueta: el saludo, cuántos precios esperan tu sí y cuánta plata hay
 * en juego, y por estrategia a dónde ir a decidir.
 *
 * No se decide acá, a propósito: cada fila lleva a Revisar precios ya filtrado,
 * que es donde se ve el contexto completo de cada precio.
 */
export default function DecisionesPage() {
  const { user } = useAuth();
  const { veEstrategias, veReglas } = usePermisosDeCompite();
  const o = useOrquestacionCompite();

  // Sin el módulo de estrategias no hay decisiones que mostrar; quien ve reglas
  // va a Reglas, que es a lo que puede entrar (P3-D10).
  if (!veEstrategias) {
    return (
      <Navigate to={veReglas ? `${RUTAS_COMPITE.estrategia}?ver=reglas` : '/dashboard'} replace />
    );
  }

  return (
    <AppLayout>
      <MarcoCompite>
        <EncabezadoCompite
          seccion="Decisiones"
          icono={Inbox}
          titulo={<Saludo nombre={user?.firstName} />}
          subtitulo="Estas son tus decisiones de hoy."
        />
        <AvisoDemo texto={AVISO_DECISIONES_DEMO} tour="demo-decisiones-aviso" />
        {o.hayCambiosNuevos && <AvisoCambiosNuevos onRecargar={o.recargar} />}
        {/* Ancla del recorrido de la demo (X3): HoyTab tiene dos caras (vacía y con decisiones). */}
        <div data-tour="demo-decisiones-hoy">
          <HoyTab onIrA={o.irA} refreshKey={o.refreshKey} />
        </div>
      </MarcoCompite>
      <VueltaSheet
        strategyApplicationId={o.vuelta}
        onClose={() => o.abrirVuelta(null)}
        onIrA={o.irA}
        onResuelto={o.alResolver}
      />
    </AppLayout>
  );
}
